import axios from 'axios';
import {
  CREW_RESERVATION_REMARKS,
  GET_RESERVATION_REMARKS,
} from '../../service/constants.service';
import {GlobalUtility} from '../../service/global-utility.service';

const state = {
  remarks : [],
  remark : {},
  newRemarks : {
    subject: null,
    remarks: null,
    crew_reservation_id : null,
  },

  notifs : [],
  notif : {},
};

const mutations = {
  set_remarks : (state,params) =>{
    state.remarks = params;
  },

  //set_remark : (state,param) =>{},

  set_new_remarks : (state,param) =>{
    state.remarks.unshift(param);
    state.newRemarks = {
      subject: null,
      remarks: null,
      crew_reservation_id : null,
    }
  },

  // set_update_remarks : (state,param) =>{},

  // set_delete_remark : (state,param) =>{},

  set_null_remarks : (state) =>{
    state.remarks = [];
  },

  set_null_remark : (state) =>{
    state.remark = {};
  },

  set_null_new_remark : (state) =>{
    state.newRemarks = {
      subject: null,
      remarks: null,
      crew_reservation_id : null,
    }
  },

  set_notifs : (state,param) => {
    state.remarks.unshift(notifs);
  },

  set_notif : (state,param) => {
    state.notif = param;
  },
};


const actions = {
  //list

  //viewRemarks(){},

  createRemarks({commit},param){
   return axios.post(CREW_RESERVATION_REMARKS,param).then((response)=>{
     commit('set_new_remarks',response.data);
     return true;
   }).catch((error)=>{
     GlobalUtility.failProgressBar();
     GlobalUtility.generateResponseMessage(error,'Create new remarks');
     return false;
   })
  },

  //updateRemarks(){},

  //deleteRemarks(){},

  setNullRemarks({commit}){
    commit('set_null_remarks');
  },

  setNullNewRemark({commit}){
    commit('set_null_new_remark');
  }
};


const getters = {
  remarks : state => state.remarks,
  remark : state => state. remark,
  newRemarks : state => state.newRemarks,
}


export default {state,actions,mutations,getters};
